"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
function fillRef(ref, node) {
    if (typeof ref === 'function') {
        ref(node);
    }
    else if (typeof ref === 'object' && ref && 'current' in ref) {
        // eslint-disable-next-line no-param-reassign
        ref.current = node;
    }
}
function useRefsCompose(...refs) {
    const refList = refs.filter(Boolean);
    if (refList.length <= 1) {
        return refList[0];
    }
    return (0, react_1.useCallback)((node) => {
        refs.forEach((ref) => fillRef(ref, node));
    }, []);
}
exports.default = useRefsCompose;
